import { Box } from "@chakra-ui/react";
import { Row, Col } from "antd";
import Field from "components/Input/Field/index";
import { RegraReservaComponentProps } from "..";
import SelectDataReferenciaBoletoReservaProps from "components/Input/SelectDataReferenciaBoletoReserva/index";
import InputMoney from "components/Input/InputMoney/index";
import { AreaComumTipoVencimentoCobrancaEnum } from "core/features/area-comum/typings";

export default function ParametrizarVencimentoBoletoReserva({
  control,
  watch,
}: RegraReservaComponentProps) {
  return (
    <Box mb="48px">
      <Row gutter={32}>
        <Col sm={6}>
          <Field
            control={control}
            label="Data de referência"
            name="tipoVencimentoCobranca"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <SelectDataReferenciaBoletoReservaProps
                value={field.value}
                defaultValue={null}
                onChange={(value) => {
                  field.onChange(value);
                }}
                isInvalid={isInvalid}
              />
            )}
          />
        </Col>

        <Col sm={6}>
          <Field
            control={control}
            shouldUnregister
            label={
              watch("tipoVencimentoCobranca") ===
              AreaComumTipoVencimentoCobrancaEnum.DiaDoEvento
                ? "Dias antes"
                : "Dias depois"
            }
            name="diasVencimentoCobranca"
            rules={{ required: "Campo obrigatório" }}
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                value={field.value}
                onChange={field.onChange}
                placeholder="0"
                step={1}
                decimalScale={0}
                decimalsLimit={0}
              />
            )}
          />
        </Col>
      </Row>
    </Box>
  );
}
